import {charcoal} from '../sass/base/_exports.sass';

export const HeartCheckIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.99 2.34264C21.9727 -0.680027 17.1327 -0.77336 14.0007 2.03864C10.8594 -0.77736 6.02869 -0.676027 3.00869 2.34264C-0.00597614 5.35864 -0.11131 10.1826 2.69402 13.324L13.998 24.6466L25.3047 13.324C28.11 10.1826 28.006 5.36664 24.99 2.34264ZM15.782 4.02264C17.8754 2.14264 21.102 2.22397 23.102 4.22664C25.0914 6.21997 25.1914 9.39597 23.3594 11.4986L13.9994 20.872L4.63936 11.4973C2.80869 9.39597 2.90869 6.21597 4.89536 4.22931C6.90069 2.22397 10.1207 2.14131 12.2207 4.02397L14.002 5.61997L15.782 4.02264ZM13.3807 16.0946L8.66602 11.38L10.5513 9.49463L13.3807 12.324L19.0367 6.66663L20.922 8.55196L13.3807 16.0946Z"
        fill={color}
      />
    </svg>
  );
};
